import React, { useState, useEffect, useRef, useContext, useCallback, useLayoutEffect } from 'react';
import { Button, Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { ConfigContext } from '../../components/Common/ConfigHelper';
import { GlobalContext } from '../../contexts/GlobalContext';
import OtpInput from 'react-otp-input';
import { getDeviceType } from '../Common/CommonHooks';
import account_opening_qrcode_1 from '../../info/Include/images/account_opening_qrcode_1.svg'
import account_opening_logo from '../../info/Include/images/account_opening_logo.png'
import step1 from '../../info/Include/images/otp_update_mobile_step1.svg'
import step2 from '../../info/Include/images/otp_update_mobile_step2.svg'
import step1ch from '../../info/Include/images/otp_update_mobile_step1_ch.svg'
import step2ch from '../../info/Include/images/otp_update_mobile_step2_ch.svg'
import QRCode from "react-qr-code"

import {Toast} from '../Common/ui-components';
import { WATrackerTrackClickEvent } from '../Common/utils/wa';

export const MissingMobile = ({
    showMsg = false,
    onClickNext,
    invalidOTP,
    isMobile,
    otp,
    setOtp,
    setIsShowOTPAuth,
    onClickEKBA,
    onClickCancelOTP,
    closeBtnEnabled = false,
    getMobile,
    resendOTP,
    isShowOTPToast,
    setIsShowOTPToast,
    setShowLoginLockPopup,
    isMissingMobile
}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { betslipMenu } = useContext(ConfigContext);
    const globalContext = useContext(GlobalContext);
    const [menuInfo, setMenuInfo] = useState(betslipMenu);
    const numericOnly = (event) => {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
    }
    const resendOtpInterval = window.globalConfig.resendOtpInterval;
    const OTP_RAO_CONFIG = window.globalConfig.OTP_RAO_CONFIG;

    // const [otp, setOtp] = useState('');
    const [resent, setResent] = useState(false);
    const [resendTimer, setResendTimer] = useState(resendOtpInterval);
    const [clearOTP, setClearOTP] = useState(true);
    const [accountOpeningURL, setAccountOpeningURL] = useState('#');
    const [isShowAccountOpeningQRCode, setIsShowAccountOpeningQRCode] = useState(false);
    const [isShowTroublePopup, setIsShowTroublePopup] = useState(false);
    const [toastApi, toastContent] = Toast.useToast({ max: 1,showTime:3000,isOTP:true});
    let mobileStyle = isMobile ? 'is-mobile' : 'is-desktop';
    useEffect(() => {
        if (isMobile) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobile]);

    useEffect(() => {
        const device = getDeviceType();

        if (device.isTablet) {
            setAccountOpeningURL('#');
        } else if (device.isDesktop) {
            setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_MHKJC'));
        } else {
            setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_SH'));
        }
        // setAccountOpeningURL('#'); // testing
    }, [navigator.platform, navigator.userAgent]);
    const handleRedirectToRAO=()=>{
        window.open(lang=='ch'?OTP_RAO_CONFIG.linkCH:OTP_RAO_CONFIG.linkEN);
    }
    const handleAccountOpeningCancelBtn = () => {
        setIsShowAccountOpeningQRCode(false);
        onClickCancelOTP();
    }

    return (
        <>
        <Popup open={isMissingMobile} closeOnDocumentClick={false} className={`comingSoonLogOutDialog logout-succ-msg otp-popup ${invalidOTP ? 'otp-invalid' : ''} ${mobileStyle}`}>
                <div className='otp-acopening'>
                    {closeBtnEnabled && (
                        <div className="otp-acopening-close" onClick={handleAccountOpeningCancelBtn}>
                            &times;
                        </div>
                    )}
                    <div className='otp-acopening-title'>{!isMissingMobile?t('LB_OTP_ACCOUNT_OPENING_TITLE'):t('LB_OTP_ACCOUNT_MISSING_MOBILE')}</div>
                    <div className='otp-acopening-message'></div>
                    <div className='otp-acopening-img-group'>
                        <img src={account_opening_logo} alt="account opening logo" className='otp-acopening-logo'/>
                        <div className='otp-acopening-app-name'>{t('LB_OTP_ACCOUNT_OPENING_APP_NAME')}       
                            <div className='otp-acopening-app-hints'>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_HINTS')}</div>
                        </div>
                  
                        {/* <img src={account_opening_qrcode_1} alt="account opening qrcode" className='otp-acopening-qrcode'/> */}
                        {!isMobile&&<div className='otp-acopening-qrcode-div'>
                            <QRCode
                                value={lang=='en'?OTP_RAO_CONFIG.linkEN:OTP_RAO_CONFIG.linkCH}
                                fgColor='#003C84'
                            />
                            <div className='otp-acopening-qrcode-label'>
                                <span>{t('LB_OTP_ACCOUNT_OPENING_QRCODE_LABEL')}</span>
                            </div>
                        </div>}
                    </div>
                    <div className='otp-acopening-message'>{t('LB_OTP_ACCOUNT_MISSING_MESSAGE_1')}</div>
                        <div className='otp-acopening-message-container'>
                            <div>
                                <img src={lang=='en'?step1:step1ch} alt="account opening logo" className='otp-acopening-step-image'/>
                                <div className='otp-acopening-step'> 
                                    <div className='otp-acopening-step-index'>1</div> 
                                    <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_STEP1')}</div> 
                                </div>
                            </div>
                            <div>
                                <img src={lang=='en'?step2:step2ch} alt="account opening logo" className='otp-acopening-step-image'/>
                                <div className='otp-acopening-step'> 
                                    <div className='otp-acopening-step-index'>2</div> 
                                    <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_STEP2')}</div> 
                                </div>
                            </div>
                    </div>
              
                    {!isMobile?
                        <div className='otp-acopening-btn-group'>
                            <div className='row1'>
                                <div className='cta_blue' onClick={() => handleAccountOpeningCancelBtn()}>{t('LB_CLOSE')}</div>
                            </div>
                            {/* <div className='row2'>
                                <div className='cancel-btn' onClick={handleAccountOpeningCancelBtn}>{t('LB_BS_LOGIN_CANCEL')}</div>
                            </div> */}
                        </div>
                    :
                        <div className='otp-acopening-btn-group'>
                            <div className='row1'>
                                <div className='cta_yellow' onClick={() => handleRedirectToRAO()}>{t('LB_OPEN')}</div>
                            </div>
                            <div className='row2'>
                                <div className='cancel-btn' onClick={() => handleAccountOpeningCancelBtn()}>{t('LB_BS_LOGIN_CANCEL')}</div>
                            </div>
                        </div>
                    }
                </div>
            </Popup>
        </>
    );
};